<template>
  <div class="ai-output">
    <div class="ai-output-head">
      <h3>{{ title }}</h3>
      <span v-if="model" class="badge badge-model">{{ model }}</span>
      <span v-if="mock" class="badge badge-mock">⚠ 演示数据</span>
      <span class="spacer" />
      <small v-if="updated" class="hint">{{ updated }}</small>
    </div>
    <div v-if="warning" class="ai-output-warning">{{ warning }}</div>
    <div v-if="loading">
      <div class="skeleton" style="width:70%" />
      <div class="skeleton" style="width:95%" />
      <div class="skeleton" style="width:85%" />
      <div class="skeleton" style="width:60%" />
    </div>
    <div v-else-if="error" class="ai-output-error">生成失败：{{ error }}</div>
    <slot v-else />
  </div>
</template>

<script>
// 所有 AI 输出的统一容器：标题 + 模型角标 + mock 角标 + 降级警示 + loading 骨架 + 内容 slot
export default {
  name: 'AIOutputCard',
  props: {
    title: { type: String, required: true },
    loading: Boolean,
    error: String,
    model: String,
    mock: Boolean,
    warning: String,
    updated: String,
  },
};
</script>
